import { $gettext } from '@/config/gettext'

const primary = [
  {
    label: $gettext('Tours'),
    routeName: 'Private/Tour'
  },
  {
    label: $gettext('Bookings'),
    routeName: 'Private/Bookings'
  },
  {
    label: $gettext('Account'),
    routeName: 'Private/Account'
  }
]

const secondary = [
  {
    label: $gettext('log out'),
    routeName: 'Private/Logout',
    icon: 'power'
  }
]

export {
  primary,
  secondary
}
